/**
 * Nom d'équipe cliquable ouvrant la fiche équipe (TeamProfileModal).
 */

import { useProfile } from '../contexts/ProfileContext';
import '../styles/profile-modal.css';

interface ClickableTeamNameProps {
  teamId: number;
  children: React.ReactNode;
  className?: string;
  title?: string;
}

export default function ClickableTeamName({ teamId, children, className = '', title }: ClickableTeamNameProps) {
  const { openTeamProfile } = useProfile();

  const open = (e?: { stopPropagation?: () => void }) => {
    e?.stopPropagation?.();
    openTeamProfile(teamId);
  };

  return (
    <span
      className={`clickable-pseudo ${className}`}
      title={title}
      onClick={(e) => open(e)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(e);
        }
      }}
    >
      {children}
    </span>
  );
}
